import React from "react"
import { Box, Heading, Text, Flex, Link, Grid } from "@theme-ui/components"
import Countdown from "react-countdown"

// Random component
const Completionist = () => <span></span>

const ClockItem = ({ time, label }) => (
  <Flex
    sx={{
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Text sx={{ fontSize: [6, 8], fontWeight: 500 }}>{time}</Text>
    <Text
      sx={{
        fontSize: [1, 3],
        textTransform: "uppercase",
        color: "#909090",
        fontWeight: 500,
      }}
    >
      {label}
    </Text>
  </Flex>
)

// Renderer callback with condition
const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return <Completionist />
  } else {
    // Render a countdown
    return (
      <Grid
        sx={{
          backgroundColor: "#292929",
          color: "#EBEBEB",
          width: "100%",
          px: [3, 6],
          py: [3, 6],
          borderRadius: "8px",
        }}
        columns={[4]}
        gap={[0]}
      >
        <ClockItem time={days} label="days" />
        <ClockItem time={hours} label="hours" />
        <ClockItem time={minutes} label="minutes" />
        <ClockItem time={seconds} label="seconds" />
      </Grid>
    )
  }
}

const EventCountdown = ({
  block,
  registrationCta,
  registrationLink,
  primaryColor,
}) => {
  const { title, date } = block
  return (
    <Flex
      sx={{
        mb: [4, 5],
        p: { m: [0] },
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Heading
        as="h3"
        variant="h1"
        sx={{
          fontSize: [5, 6],
          fontWeight: 400,
          color: "dark",
          mb: [4, 5],
          textAlign: "center",
        }}
      >
        {title}
      </Heading>
      <Countdown date={date} renderer={renderer} />
      {registrationCta && registrationLink && (
        <Link
          href={registrationLink}
          variant="buttons.button"
          target="_blank"
          sx={{
            mt: [4, 5],
            display: "inline-block",
            color: "light",
            backgroundColor: primaryColor.hex || "primary",
          }}
        >
          {registrationCta}
        </Link>
      )}
    </Flex>
  )
}

export default EventCountdown
